import { isToday, isTomorrow } from 'date-fns';
import { defaultDateFormatter } from '@cp/shared/lib';

export const formatDateLabel = (date: Date | undefined): string => {
  if (!date) {
    return '';
  }
  if (isToday(date)) {
    return 'Сегодня';
  } else if (isTomorrow(date)) {
    return 'Завтра';
  } else {
    return defaultDateFormatter(date);
  }
};
